import React, { useState } from 'react';
import { useEffect } from 'react';
import Question from '../../../assets/img/dashboard/question';
import { InputNumber, Tooltip } from 'antd';
import constants from '../../../lib/constants/constants';

const RefSensorType = ({ selectedItem, handlePostData, action }) => {
  const [deviceSetting, setDeviceSetting] = useState(false);

  const [humidity, setHumidity] = useState(null);
  const [temperature, setTemperature] = useState(null);

  const [maxTempSet, setMaxTempSet] = useState(null);
  const [miniTempSet, setMiniTempSet] = useState(null);
  const [maxHumSet, setMaxHumSet] = useState(null);
  const [miniHumSet, setMiniHumSet] = useState(null);

  const [newMiniTempSet, setNewMiniTempSet] = useState(null);
  const [newMaxTempSet, setNewMaxTempSet] = useState(null);
  const [newMaxHumSet, setNewMaxHumSet] = useState(null);
  const [newMiniHumSet, setNewMiniHumSet] = useState(null);

  const [showWarning, setShowWaring] = useState(false);

  const alarmMinMaxRange = {
    celsius: {
      minTemperature: {
        min: -40,
        max: 185
      },
      maxTemperature: {
        min: -4,
        max: 200
      }
    }
  };

  useEffect(() => {
    setHumidity(selectedItem.deviceState.humidity);
    setTemperature(selectedItem.deviceState.temperature);
    setMiniTempSet(selectedItem.deviceState.miniTempSet);
    setMaxTempSet(selectedItem.deviceState.maxTempSet);

    setMiniHumSet(selectedItem.deviceState.miniHumSet);
    setMaxHumSet(selectedItem.deviceState.maxHumSet);

    if (deviceSetting) setDeviceSetting(false);
  }, [
    selectedItem.deviceState.humidity,
    selectedItem.deviceState.temperature,
    selectedItem.deviceState.maxTempSet,
    selectedItem.deviceState.miniTempSet,
    selectedItem.deviceState.maxHumSet,
    selectedItem.deviceState.miniHumSet,
    deviceSetting
  ]);

  const SensorInfo = () => {
    return (
      <div className="display">
        <p className="temperature">{`${temperature}℃`}</p>
        <span className="divide-line" />
        <p className="humidity">{humidity}%</p>
      </div>
    );
  };

  const AlarmInformation = () => {
    const temperatureConvertToText = settingValue => {
      if (settingValue === null) settingValue = 0;

      return `${Number(settingValue).toFixed(1)}℃`;
    };

    const humidityConvertToText = settingValue => {
      if (settingValue === null) settingValue = 0;
      return `${settingValue}%`;
    };

    return (
      <div className="setting">
        <div className="temperature">
          <span className="information-line">
            온도가{' '}
            <span className="temperature-value">
              {temperatureConvertToText(miniTempSet)}
            </span>
            보다 낮을때,{' '}
            <span className="temperature-value">
              {temperatureConvertToText(maxTempSet)}
            </span>
            보다 높을때
          </span>
          <span className="information-line">
            습도가{' '}
            <span className="humidity-value">
              {humidityConvertToText(miniHumSet)}
            </span>
            보다 낮을때,{' '}
            <span className="humidity-value">
              {humidityConvertToText(maxHumSet)}
            </span>
            보다 높을때
          </span>
        </div>
      </div>
    );
  };

  const SettingAlaramInfo = () => {
    let _minTemp, _maxTemp, _minHum, _maxHum;

    _minTemp = newMiniTempSet === null ? miniTempSet : newMiniTempSet;
    _maxTemp = newMaxTempSet === null ? maxTempSet : newMaxTempSet;
    _minHum = newMiniHumSet === null ? miniHumSet : newMiniHumSet;
    _maxHum = newMaxHumSet === null ? maxHumSet : newMaxHumSet;

    if (
      Number(_minTemp) >= Number(_maxTemp) ||
      Number(_minHum) >= Number(_maxHum)
    ) {
      setShowWaring(true);
    } else {
      const sensorSettingValue = {
        maxTempSet: _maxTemp,
        miniTempSet: _minTemp,
        maxHumSet: _maxHum,
        miniHumSet: _minHum
      };

      handlePostData(null, sensorSettingValue, 'refSensorManagement');
      action();
    }
  };

  const AlarmToolTip = () => {
    let min = alarmMinMaxRange.celsius.minTemperature.min + '℃';
    let max = alarmMinMaxRange.celsius.maxTemperature.max + '℃';

    return (
      <Tooltip
        placement="right"
        color="#2D3034"
        title={
          <>
            <p>
              {' '}
              온도범위 : {min} ~ {max}
            </p>
            <p> 습도범위 : 0% ~ 100%</p>
          </>
        }
      >
        <span className="tooltip-icon">
          <Question />
        </span>
      </Tooltip>
    );
  };

  const getMiniRange = alarmType => {
    return alarmMinMaxRange.celsius[alarmType].min;
  };

  const getMaxRange = alarmType => {
    return alarmMinMaxRange.celsius[alarmType].max;
  };

  const _checkMiniTemp = value => {
    if (showWarning) setShowWaring(false);
    setMiniTempSet(value);
    setNewMiniTempSet(value);
  };

  const _checkMaxTemp = value => {
    if (showWarning) setShowWaring(false);
    setMaxTempSet(value);
    setNewMaxTempSet(value);
  };

  const _checkMiniHum = value => {
    if (showWarning) setShowWaring(false);
    setMiniHumSet(value);
    setNewMiniHumSet(value);
  };

  const _checkMaxHum = value => {
    if (showWarning) setShowWaring(false);
    setMaxHumSet(value);
    setNewMaxHumSet(value);
  };

  const onHistoryClick = () => {
    window.location.href = `${constants.URL.HISTORY}?familyId=${
      selectedItem.familyId
    }&roomId=${selectedItem.roomId ? selectedItem.roomId : 'ALL'}&deviceId=${
      selectedItem.id
    }`;
  };

  return (
    <>
      <section className="device-setting-body refsensor-wrap">
        <button onClick={onHistoryClick} className="history-button">
          히스토리
          <svg
            width={18}
            height={18}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7.72 5.47a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 0 1-1.06-1.06L10.19 9 7.72 6.53a.75.75 0 0 1 0-1.06Z"
              fill="#EAEAEA"
            />
          </svg>
        </button>
        <div className="device-display converter">
          <span className="sensor-title">실시간 온·습도</span>
        </div>
        <div className="device-display sensor-information">
          <SensorInfo />
        </div>
        <div className="device-display converter-alarm">
          <span className="sensor-title">경보 알람</span>
        </div>
        <div className="device-display alarm-information">
          <AlarmInformation />
        </div>
        <div className="device-control-wrap">
          <span className="sensor-title-question">
            경보 알람 설정
            <AlarmToolTip />
          </span>
          <div className="sensor-information-control">
            <div className="temperature">
              <span className="temperature-title">온도 : </span>
              <div className="temperature-setting">
                <span className="alarm-input-title"> 이하 </span>
                <InputNumber
                  className="alarm-input-number"
                  value={miniTempSet}
                  onChange={value => {
                    _checkMiniTemp(value);
                  }}
                  min={getMiniRange('minTemperature')}
                  max={getMaxRange('minTemperature')}
                  step={0.1}
                  controls={false}
                  precision={1}
                  addonAfter="℃"
                />
              </div>
              <div className="temperature-setting">
                <span className="alarm-input-title">
                  <span className="divide-line">/</span>
                  이상
                </span>
                <span>
                  <InputNumber
                    className="alarm-input-number"
                    value={maxTempSet}
                    onChange={value => {
                      _checkMaxTemp(value);
                    }}
                    min={getMiniRange('maxTemperature')}
                    max={getMaxRange('maxTemperature')}
                    step={0.1}
                    controls={false}
                    precision={1}
                    addonAfter="℃"
                  />
                </span>
              </div>
            </div>
            <div className="humidity">
              <span className="humidity-title">습도 : </span>
              <div className="humidity-setting">
                <span className="alarm-input-title"> 이하 </span>
                <InputNumber
                  className="alarm-input-number"
                  value={miniHumSet}
                  onChange={value => {
                    _checkMiniHum(value);
                  }}
                  min={getMiniRange('minTemperature')}
                  max={getMaxRange('minTemperature')}
                  step={1}
                  controls={false}
                  precision={1}
                  addonAfter={'%'}
                />
              </div>
              <div className="temperature-setting">
                <span className="alarm-input-title">
                  <span className="divide-line">/</span>
                  이상
                </span>
                <InputNumber
                  className="alarm-input-number"
                  value={maxHumSet}
                  onChange={value => {
                    _checkMaxHum(value);
                  }}
                  min={getMiniRange('maxTemperature')}
                  max={getMaxRange('maxTemperature')}
                  step={1}
                  controls={false}
                  precision={1}
                  addonAfter={'%'}
                />
              </div>
            </div>
          </div>
        </div>
        {showWarning && (
          <div className="temperature-setting-warning-text">
            <span>올바른 범위의 값을 입력해주세요.</span>
          </div>
        )}
      </section>
      <section className="device-setting-footer">
        <div className="device-button" onClick={SettingAlaramInfo}>
          <button> 저장 </button>
        </div>
      </section>
    </>
  );
};

export default RefSensorType;
